import { Guid, Nillable } from '@web/utils';
import { OrderNumber } from '../../shared/types';
import { OrderStatus } from '../../shared/enums';
import { RefundSummary } from '../../shared/models';

export class PublicSubscriptionOrderCollectionItem {
  public constructor(
    private readonly data: {
      id: Guid;
      number: OrderNumber;
      status: OrderStatus;
      totalItems: number;
      totalPrice: number;
      createdAt: Date;
      refundSummary?: Nillable<RefundSummary>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get number(): OrderNumber {
    return this.data.number;
  }

  public get status(): OrderStatus {
    return this.data.status;
  }

  public get totalItems(): number {
    return this.data.totalItems;
  }

  public get totalPrice(): number {
    return this.data.totalPrice;
  }

  public get refundSummary(): Nillable<RefundSummary> {
    return this.data.refundSummary;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }
}
